import React from "react";
import "./Pricing.css";
import Table from "./Table";

const Pricing = () => {
  return (
    <div className="pricing">
      <div>
        <div className="header">Pricing and Packages</div>
        <div className="desc">
          At CDRReportWriters, we are committed to delivering top-quality services at highly competitive prices. We guarantee the best value for your money, and if you find another
          provider offering the same level of quality at a lower price, we’ll gladly match their offer.
        </div>
        <div className="header">CDR</div>
        <Table
          heading={["Features", "Standard", "Premium", "Royal"]}
          rows={[
            ["Pricing", "$699", "$1399", "$2599"],
            ["Delivary Date", "30 Working Days", "20 Working Days", "10 Working Days"],
            ["1 CPD", true, true, true],
            ["3 Career Episodes", true, true, true],
            ["1 Summary Statement", true, true, true],
            ["Plagiarism Free", true, true, true],
            ["After Advice Support", false, true, true],
            ["Project Report", false, false, true],
          ]}
        />
        <a href="https://api.whatsapp.com/send?phone=61488877505">Order Now</a>
        <div className="header">RPL</div>
        <Table
          heading={["RPL Report Service", "20 Days Plan", "7 Days Plan", "3 Days Plan"]}
          rows={[
            ["Complete RPL Report", "$699", "$999", "$1399"],
            ["Project Writing", "$199", "$299", "$449"],
            ["Key Areas Of Knowledge", "$199", "$249", "$349"],
            ["RPL Report Review", "FREE"],
            ["RPL Editing & Proofreading", "$499", "$699", "$1199"],
            ["Complete RPL Report Rewriting", "$499", "$799", "$1299"],
            ["RPL Report Plagiarism Check", "$49"],
            ["Project Plagiarism Check", "$49"],
            ["Resume Writing", "$149"],
            ["Reference Letter", "$199"],
          ]}
        />
        <a href="https://api.whatsapp.com/send?phone=61488877505">Order Now</a>
        <div className="header">KA02</div>
        <Table
          heading={["KA02 Services", "20 Days Plan", "7 Days Plan", "3 Days Plan"]}
          rows={[
            ["Complete KA02 Report", "$699", "$999", "$1399"],
            ["Episode Writing", "$199", "$299", "$449"],
            ["Summary Writing", "$199", "$249", "$349"],
            ["KA02 Report Review", "FREE"],
            ["KA02 Report Editing & Proofreading", "$499", "$699", "$1199"],
            ["Complete KA02 Report Rewriting", "$499", "$799", "$1299"],
            ["KA02 Report Plagiarism Check or Project Plagiarism Check", "$49"],
            ["Resume Writing", "$149"],
          ]}
        />
        <a href="https://api.whatsapp.com/send?phone=61488877505">Order Now</a>
        <div className="header">NER Services</div>
        <Table
          heading={["Services", "15 Days Plan", "7 Days Plan", "3 Days Plan"]}
          rows={[
            ["NER services", "$699", "$999", "$1399"],
            ["Work Statement only", "$199", "$299", "$449"],
            ["CPD only", "$199", "$249", "$349"],
            ["Plagiarism Check", "$99"],
            ["Documents Lodgment on EA Website", "$49"],
          ]}
        />
        <a href="https://api.whatsapp.com/send?phone=61488877505">Order Now</a>
      </div>
    </div>
  );
};

export default Pricing;
